import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1220px;
  margin: 0 40px;
  display: flex;
  flex-direction: column;
`;

export const Route = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  padding: 8px 0;
  border-bottom: 1px solid #888;
`;

export const Title = styled.p`
  margin-top: 32px;
  color: #004e9a;
  font-weight: bold;
  text-align: center;
`;

export const OrientationTitle = styled.strong`
  width: 100%;
  max-width: 200px;
  text-align: center;
  text-decoration: underline;
`;

export const OrientationImg = styled.img`
  max-width: 200px;
  height: auto;
`;

export const OrientationDescription = styled.p`
  width: 100%;
  text-align: center;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  label {
    cursor: pointer;
  }
`;
